import httpClient from "@/api/httpClient";
import {
  IAddInventoryRequest,
  IAddInventoryResponse,
  IInventoryResponse,
  ISearchInventoryResponse,
} from "./inventory.interface";
import { IPagination } from "@/commons/commons.interfaces";

export const addInventoryService = async (
  inventory: IAddInventoryRequest
): Promise<IAddInventoryResponse> => {
  try {
    const response = await httpClient.post("/v1/inventory", inventory);
    return response.data;
  } catch (e) {
    throw e;
  }
};

export const getInventoryService = async (
  page: number = 0,
  limit: number = 10,
  sort: string = "",
  order: "asc" | "desc" | "" = "",
  search: string = ""
): Promise<{
  pagination: IPagination;
  products: IInventoryResponse[];
}> => {
  try {
    const params: any = {
      page,
      limit,
    };

    if (sort) {
      params.sort = sort;
    }
    if (order) {
      params.order = order;
    }
    if (search) {
      params.search = search;
    }

    const response = await httpClient.get("/v1/inventory", { params });
    return response.data;
  } catch (e) {
    throw e;
  }
};

export const searchInventoryService = async (
  search: string
): Promise<ISearchInventoryResponse[]> => {
  try {
    const response = await httpClient.get("/v1/inventory/search", {
      params: { q: search },
    });
    return response.data;
  } catch (e) {
    throw e;
  }
};
